import applicationBootstrap from 'website/bootstrap';
import jumpAffiliation from 'website/module/ui/jump-affiliation';

// bootstrap the application / store
applicationBootstrap().then(() => {
  jumpAffiliation();
});
